import React, { useState } from 'react';
import OutletHead from '../../../../components/common/outlet-head';
import PartyForm from '../../../../components/forms/party-form';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { IoArrowBackOutline } from 'react-icons/io5';
import { v4 as uuidv4 } from 'uuid';
import { doc, setDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { db } from '../../../../firebase';
import { storage } from '../../../../firebase';
import { useAuth } from '../../../../context/AuthContext';

function AddParty() {

  let navigate = useNavigate();

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(false);
  const [imageSource, setImageSource] = useState('');
  const [partyData, setPartyData] = useState({
    partyName: '',
    fatherHusband: '',
    partyType: 'Customer',
    gender: '',
    dob: '',
    occupation: '',
    panNumber: '',
    gst: '',
    aadharNumber: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    state: '',
    photo: '',
    bankDetails: []
  });
  const [inputError, setInputError] = useState(null);

  const fireData = async (id, data) => {
    data = { ...data, addedOn: new Date(), updatedOn: new Date() };
    try {
      await setDoc(doc(db, "Businesses", bid, "Parties", id), data);
      setIsLoading(false);
      navigate(-1);
    } catch (error) {
      console.log('Adding Party Data [Error] : ', error);
      setIsLoading(false);
    }
  }

  const fireDataWithPhoto = async (id, data, imageObj) => {
    const storageRef = ref(storage, `/Parties/${id}`);

    const uploadTask = uploadBytesResumable(storageRef, imageObj);

    uploadTask.on("state_changed", (snapshot) => {
      const percent = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
    }, (err) => console.log('Party Photo Uploading [Error] :', err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          var tempData = { ...data }
          tempData.photo = url;
          fireData(id, tempData);
        });
      }
    );
  }

  function validateAndPostData() {
    const { partyName, fatherHusband, gender, dob, occupation, aadharNumber, phoneNumber, address, city, pincode, state } = partyData;
    if (!partyName) {
      setInputError({ ...inputError, partyName: 'This field is required.' });
    } else if (!fatherHusband) {
      setInputError({ ...inputError, fatherHusband: 'This field is required.' });
    } else if (!gender) {
      setInputError({ ...inputError, gender: 'This field is required.' });
    } else if (!dob) {
      setInputError({ ...inputError, dob: 'This field is required.' });
    } else if (!occupation) {
      setInputError({ ...inputError, occupation: 'This field is required.' });
    } else if (!aadharNumber) {
      setInputError({ ...inputError, aadharNumber: 'This field is required.' });
    } else if (!phoneNumber) {
      setInputError({ ...inputError, phoneNumber: 'This field is required.' });
    } else if (!address) {
      setInputError({ ...inputError, address: 'This field is required.' });
    } else if (!pincode) {
      setInputError({ ...inputError, pincode: 'This field is required.' });
    } else if (!city) {
      setInputError({ ...inputError, city: 'This field is required.' });
    } else if (!state) {
      setInputError({ ...inputError, state: 'This field is required.' });
    } else {
      let uuid = uuidv4();
      setIsLoading(true);
      if (imageSource) {
        fireDataWithPhoto(uuid, partyData, imageSource);
      } else {
        fireData(uuid, partyData);
      }
    }
  }

  return (
    <section className='section'>
      <OutletHead
        left={
          <div className='d-flex align-items-center'>
            <Button
              variant='light'
              size='sm'
              className='p-2 me-3 rounded-circle'
              onClick={() => navigate(-1)}
            >
              <IoArrowBackOutline size={24} />
            </Button>
            <h5 className='mb-0'>Add Party</h5>
          </div>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="light"
              className='border py-2 px-4 me-3 btn-width'
              onClick={() => navigate(-1)}
            >
              <span>Cancel</span>
            </Button>
            <Button
              variant="primary"
              className='py-2 px-5 btn-width'
              onClick={validateAndPostData}
            >
              Save
            </Button>
          </div>
        }
      />
      <div className='px-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='mb-5 position-relative'>
              {
                isLoading ?
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                  :
                  <PartyForm
                    data={partyData}
                    setData={setPartyData}
                    imageSource={imageSource}
                    setImageSource={setImageSource}
                    inputError={inputError}
                    setInputError={setInputError}
                  />
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AddParty;
